// extracted by mini-css-extract-plugin
export default {"button":"followButton_button__5K5W9","active":"followButton_active__DSsOj"};